import { render, staticRenderFns } from "./SslcommerzPaymentStatus.vue?vue&type=template&id=6ac63f9e"
import script from "./SslcommerzPaymentStatus.vue?vue&type=script&lang=js"
export * from "./SslcommerzPaymentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports